/* eslint-disable import/no-cycle */
import useApiHelpers from '@/composables/api/helpers';
import { useBuyOrderFormStore } from '@/stores/forms/buyOrderFormStore';
import { useSellOrderFormStore } from '@/stores/forms/sellOrderFormStore';

export default function useTracker() {
  const getOrderMode = () => JSON.parse(localStorage.getItem('mode'));

  const getSellOrderData = () => {
    const { getTrackingInformation } = useSellOrderFormStore();
    return getTrackingInformation;
  };

  const getBuyOrderData = () => {
    const { getTrackingInformation } = useBuyOrderFormStore();
    return getTrackingInformation;
  };

  const getOrderData = () => {
    const mode = getOrderMode().toLowerCase();
    let orderData = {};
    // Used switch case here to extend to NFT-BUY and NFT-SELL in the future
    switch (mode.toLowerCase()) {
      case 'buy':
        orderData = { ...getBuyOrderData() };
        break;
      case 'sell':
        orderData = { ...getSellOrderData() };
        break;
      default:
        break;
    }

    return orderData;
  };

  const sendTrackerEvent = async (event = {}) => {
    const { postRequest } = useApiHelpers();
    const { host, pathname, referrer } = window.location;
    const defaultData = {
      page: {
        host,
        pathname,
        referrer,
      },
      order: {
        ...getOrderData(),
      },
    };

    const {
      type = 'FRONTEND_ORDER_JOURNEY',
      subtype = 'PAGE_VISIT',
      data,
    } = event;

    try {
      const response = await postRequest('/track', {
        data: {
          ...defaultData,
          ...data,
        },
        event_type: type,
        event_sub_type: subtype,
      });
      return response;
    } catch (err) {
      throw new Error(err);
    }
  };

  return {
    sendTrackerEvent,
  };
}
